// extracted by mini-css-extract-plugin
module.exports = {"notes":"ShortenedText_notes__37TJA","preserveLineBreaks":"ShortenedText_preserveLineBreaks__1geL4","srOnly":"ShortenedText_srOnly__jZ1tz"};